'use client';
import { compact } from '../compact.js';
import { pluralize } from '../str.js';

/**
 * Format time from minutes
 * @param timeInMinutes - The time in minutes
 * @param options - The options to use
 * @param options.longFormatting - Whether to use long formatting [default: false]
 * @param options.showZeroUnits - Whether to show zero units (e.g. 0h 0m) [default: false]
 * @returns The formatted time
 */
function formatTimeFromMinutes(timeInMinutes, { longFormatting, showZeroUnits } = {}) {
    if (!timeInMinutes && !showZeroUnits) {
        return longFormatting ? pluralize(0, 'hour') : '0h';
    }
    const isNegative = timeInMinutes < 0;
    const absTimeInMinutes = Math.abs(timeInMinutes);
    const hours = Math.floor(absTimeInMinutes / 60);
    const minutes = absTimeInMinutes % 60;
    const joinStr = longFormatting ? ' and ' : ' ';
    const hourStr = hours > 0 || showZeroUnits
        ? longFormatting
            ? pluralize(hours, 'hour')
            : `${hours}h`
        : null;
    const minuteStr = minutes > 0 || showZeroUnits
        ? longFormatting
            ? pluralize(minutes, 'minute')
            : `${minutes}m`
        : null;
    return `${isNegative ? '-' : ''}${[hourStr, minuteStr].filter(compact).join(joinStr)}`;
}

export { formatTimeFromMinutes };
//# sourceMappingURL=format-time-from-minutes.js.map
